import type { StoreListItem } from '../types/api';

/** When set, tele queues only load visits for this store (prod TELE = 200; local usually unset = all stores). */
const configured = (process.env.REACT_APP_TELECONSULT_QUEUE_STORE_ID ?? '').trim();
const parsed = configured === '' ? NaN : Number.parseInt(configured, 10);

export const TELECONSULT_QUEUE_STORE_ID =
  Number.isFinite(parsed) && parsed > 0 ? parsed : null;

/** Shown only while the locked store list is still loading / unavailable. */
const LOCKED_STORE_LABEL_FALLBACKS: Record<number, string> = {
  1: 'NC',
  200: 'TELE',
};

export function defaultTeleconsultStoreFilter(): string {
  return TELECONSULT_QUEUE_STORE_ID != null ? String(TELECONSULT_QUEUE_STORE_ID) : '';
}

export function isTeleconsultQueueStoreLocked(): boolean {
  return TELECONSULT_QUEUE_STORE_ID != null;
}

export function filterStoresForTeleconsultQueue(stores: StoreListItem[]): StoreListItem[] {
  if (TELECONSULT_QUEUE_STORE_ID == null) return stores;
  return stores.filter((s) => s.id === TELECONSULT_QUEUE_STORE_ID);
}

export function resolveTeleconsultQueueStoreId(storeFilter: string): number | undefined {
  if (TELECONSULT_QUEUE_STORE_ID != null) return TELECONSULT_QUEUE_STORE_ID;
  if (!storeFilter.trim()) return undefined;
  const n = Number.parseInt(storeFilter, 10);
  return Number.isNaN(n) ? undefined : n;
}

/** Clinic label for the locked queue filter bar (never hardcode KA). */
export function formatTeleconsultQueueStoreLabel(stores: StoreListItem[]): string {
  const store = stores[0];
  if (store) {
    const code = (store.code ?? '').trim();
    const name = (store.storeName ?? '').trim();
    if (code && name) return `${code} — ${name}`;
    if (code) return code;
    if (name) return name;
  }
  if (TELECONSULT_QUEUE_STORE_ID != null) {
    return (
      LOCKED_STORE_LABEL_FALLBACKS[TELECONSULT_QUEUE_STORE_ID] ??
      `Store ${TELECONSULT_QUEUE_STORE_ID}`
    );
  }
  return 'Loading clinic…';
}
